<template>
    <div class="fixed-scroller">
        <div class="v-alert w-600">
            <header><p>Refer Activity - <span style="font-weight: bold;">{{ refer.name + ' - ' + format(refer.created,'dd/MM/yy HH:mm') }}</span></p><div class="x" @click="$emit('emit',{ action: 'exit' })"></div></header>
            <div class="refer-box">
                <div class="box-left">
                    <p>Referal</p>
                    <div v-for="join in refer.joins">
                        <p>{{ join.name }}</p>
                        <p>{{ format(join.now,'dd/MM/yy HH:mm') }}</p>
                    </div>
                </div>
                <div class="box-right">
                    <p>Visits</p>
                    <div v-for="land in refer.lands">
                        <p>{{ format(land,'dd/MM/yy HH:mm') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js';
import { format } from 'date-fns';

export default {
    props: ['item'],
    computed: {
        client_id () { return this.$store.state.client_id },
        customers () { return this.$store.state.DB.customers }
    },
    data () {
        return {
            format,
            refer: {}
        }
    },
    mounted () {
        WebSoc.SEND('get',{ DB: 'refer-links', _id: this.item._id },refer => {
            if ( !refer.name ) {
                var customer = this.customers.find(c => c._id == refer.customer_id);
                refer.name = customer ? customer.name : 'no name'; 
            }
            (refer.joins  || []).forEach(join => {
                if ( !join.name ) {
                    var customer = this.customers.find(c => c._id == join.customer_id);
                    join.name = customer ? customer.name : 'no name'
                }
            });

            this.refer = refer;
        })
    }
}

</script>

<style scopped lang="scss">
.refer-box {
    display: grid;
    grid-template-columns: 300px 1fr;
    max-height: 400px;
    min-height: 400px;
    > div {
        margin: 5px;
        position: relative;
        overflow: scroll;
        max-height: 390px;
        min-height: 390px;
        float: left;
        > * {
            padding: 5px;
        }
        > div {
            display: grid;
            &:nth-child(odd) { background-color: rgba(100,100,100,0.3); }
        }
    }
    .box-left {
        > div {
            grid-template-columns: 130px 150px;
        }
    }
}
</style>